export default __webpack_public_path__ + "static/media/failGif.95f72878.gif";